import type { GrantEntry } from "../../../../shared/rbac/roles";

type ScopeGrantRow = {
  userId?: string | null;
  userGroupId?: string | null;
  serviceAccountId?: string | null;
  builtinRoleId?: string | null;
  customRoleId?: string | null;
};

type RoleRef = { builtinRoleId?: string; customRoleId?: string };

export function buildScopeDesired(
  scopeGrants: readonly ScopeGrantRow[],
  memberId: string,
  desiredRoles: readonly RoleRef[]
): GrantEntry[] {
  return [
    ...scopeGrants
      // Keep every grant whose principal isn't this member. The filter is
      // `userId !== memberId` (not `userId && userId !== memberId`): group and
      // service-account grants have a null userId, so they must be preserved too.
      .filter((g) => g.userId !== memberId)
      .map((g) => ({
        userId: g.userId ?? undefined,
        userGroupId: g.userGroupId ?? undefined,
        serviceAccountId: g.serviceAccountId ?? undefined,
        builtinRoleId: g.builtinRoleId ?? undefined,
        customRoleId: g.customRoleId ?? undefined,
      })),
    ...desiredRoles.map((r) => ({
      userId: memberId,
      builtinRoleId: r.builtinRoleId,
      customRoleId: r.customRoleId,
    })),
  ];
}
